<div class="row">
    <div class="col-12" [ngClass]="IsShowSection ? 'col-xl-9 col-lg-9 col-md-9 eip-pl-0': 'col-xl-12 col-lg-12 col-md-12 eip-pl-20'">
        <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
            <kendo-grid [kendoGridBinding]="orgList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMOrgList" [height]="700">
                <ng-template kendoPagerTemplate>
                    <div class="k-pager-left">
                        <kendo-pager-info></kendo-pager-info>
                    </div>
                    <div class="k-pager-right">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-input></kendo-pager-input>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                </ng-template>
                <ng-template kendoGridToolbarTemplate>
                    <div class="k-grid-toolbar-content d-flex">
                        <div class="flex-grow-1 mat-panel-headerbar"></div>
                        <div class="pagination-container">
                            <p id="lblShowDetails">Show</p>
                            <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                            </kendo-pager-page-sizes>
                            <span>Items</span>
                        </div>
                        <div class="divider-container d-none d-md-block" id="imgDivider">
                            <span></span>
                        </div>
                        <div class="icons-container">
                            <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                            <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                <div class="icon-wrap" (click)=" toggleFilter()">
                                    <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                                    <span class="list-icon-name">Filter</span>
                                </div>
                                <div class="icon-wrap" (click)="toggleFullscreen()">
                                    <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                    <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                </div>
                            </div>
                            <div class="divider-container"><span></span></div>
                            <i class="fa fa-plus-circle icon-my-10" title="Add Organization" (click)="addEditOrganization()" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        {{rowIndex+1}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Group Short Name" field="group_Short_Name" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.group_Short_Name}}" eipTooltipPosition="auto">{{dataItem.group_Short_Name}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Group Name" field="group_Name" [width]="200">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.group_Name}}" eipTooltipPosition="auto">{{dataItem.group_Name}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Group Code" field="group_Code" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.group_Code}}" eipTooltipPosition="auto">{{dataItem.group_Code}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Logo URL" field="group_Logo_URL" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.group_Logo_URL}}" eipTooltipPosition="auto">{{dataItem.group_Logo_URL}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Created By" field="created_By" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">{{dataItem.created_By}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Created On" field="created_On" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.created_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.created_On| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Modified By" field="modified_By" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto">{{dataItem.modified_By}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <span class="no-wrap" eipTooltip="{{dataItem.modified_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.modified_On| date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Is Active" field="is_Active" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.is_Active" [disabled]="true" [size]="smaller"></kendo-switch>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="Action" [width]="50" class="text-center">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <i class="fa fa-pencil icon-my-10 eip-link" style="font-size: 1.25em; cursor: pointer;" (click)="addEditOrganization(dataItem)" aria-hidden="true"  title="Edit Organization" id="btnEDMEdit"></i>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>